import React, {useState,useEffect, useContext, createContext} from "react"
import axios from "axios";
const AuthContext = createContext();
const AuthProvider = ({children})=>{
    const [auth, setAuth] = useState('')

  axios.defaults.headers.common["Authorization"] =   auth?.token!==''?'Bearer '+auth?.token:'Bearer EjMoPLugjVHcQrSWdv16Jb4feUlCpOp28wXTmxUxakXuFwy1hkdlozyuzHjt9gThiqj9KXiSWb9fsi1t5CfK9A7zMooOa8bttcvjb0YDQfipDp8wzG6YMk5o';
    useEffect(()=>{   
            const data = localStorage.getItem('auth')
            const parseData = JSON.parse(data);
           
            if(parseData && parseData.user !== null) {
                setAuth({
                    user:parseData.user,
                    token:parseData.token
                })
            }
            //eslint-disable-next-line
    },[])
    return (
        <AuthContext.Provider value={[auth,setAuth]}>
            {children}
        </AuthContext.Provider>
    )
}
const useAuth = ()=>useContext(AuthContext);
export {useAuth, AuthProvider};